module.exports = __webpack_public_path__ + "img/marker.f4b42683.svg";